import React from 'react';
import Page from "../../Page/Page";
import ManageBudgetComponent from './ManageBudgetComponent/ManageBudgetComponent';

const ManageBudget = () => {
    return(
        <Page>
            <ManageBudgetComponent />
        </Page>
    )
};

export default ManageBudget;
